import React from "react";
import StaticPage from "../components/StaticPage";

const CONTENT = {
  "ai-chatbot": { kicker: "Solutions · AI Chatbot", title: "Conversational AI that closes deals 24/7.", body: [
    "Our AI Chatbot is trained on your business, products, FAQs, and tone. It greets visitors instantly, qualifies them, answers questions, and books meetings — all while never sleeping.",
    "Deployed on your website, WhatsApp, Instagram, and Messenger from a single brain. Connected directly to your CRM so every conversation feeds your pipeline.",
    "Average results: 7.2× more qualified leads, 38% reduction in support cost, sub-2-second response time.",
  ]},
  "voice-ai": { kicker: "Solutions · Voice AI", title: "An AI receptionist that sounds remarkably human.", body: [
    "MUNNEXA Voice AI answers your phone with the warmth of a human and the consistency of software. It books appointments, qualifies callers, takes orders, and routes urgent calls.",
    "Available in English, Mandarin, Malay, Tamil, and Hindi — tuned for Singapore SMEs.",
    "Captures every missed call into your CRM. Never lose a lead to voicemail again.",
  ]},
  "crm-brain": { kicker: "Solutions · CRM Brain", title: "A unified memory across every customer touchpoint.", body: [
    "CRM Brain ingests data from your chat, voice, email, ads, website, and POS — then surfaces the next best action for every contact.",
    "Predicts churn, recommends upsells, scores deals, and triggers automations the moment intent appears.",
    "Built on top of your existing CRM (HubSpot, Salesforce, Pipedrive) or used standalone.",
  ]},
  "automation": { kicker: "Solutions · Automation", title: "Workflows that run your business while you sleep.", body: [
    "From the moment a lead arrives to the invoice that gets paid — every step automated, every handoff instant.",
    "We design, build, and maintain custom n8n + AI workflows tailored to your operations. Email sequences, WhatsApp follow-ups, lead routing, document generation, dunning, recall — all handled.",
    "Typical client saves 40–120 hours per month on manual operations.",
  ]},
};

export default function SolutionPage({ slug, openChat }) {
  const c = CONTENT[slug] || CONTENT["ai-chatbot"];
  return (
    <StaticPage kicker={c.kicker} title={c.title} openChat={openChat}>
      {c.body.map((p) => (<p key={p.slice(0, 24)}>{p}</p>))}
    </StaticPage>
  );
}
